/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./downlinksActility.vue?vue&type=template&id=870f05c8&scoped=true&"
import script from "./downlinksActility.vue?vue&type=script&lang=js&"
export * from "./downlinksActility.vue?vue&type=script&lang=js&"
import style0 from "./downlinksActility.vue?vue&type=style&index=0&id=870f05c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870f05c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VContainer,VRow,VTextField})
